export const RESULTS_LIST_LENGTH = 25;
